import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API = 'https://v-room.app/api';

export default function VroomkiPage() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [post, setPost] = useState(null);

  useEffect(() => {
    if (!id) {
      setError('Brak identyfikatora VROOMKI');
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/vroomki/public/${id}`);
        if (!res.ok) throw new Error('Nie znaleziono VROOMKI');
        setPost(await res.json());
      } catch (e) {
        setError(e?.message ?? 'Błąd ładowania');
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const appUrl = `vroom://vroomki?id=${id}`;
  const openApp = () => {
    window.location.href = appUrl;
    setTimeout(() => {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.vroom.app';
    }, 1500);
  };

  const cover = post?.videos?.[0] ?? post?.photos?.[0] ?? post?.car?.photos?.[0] ?? null;

  return (
    <div className="vroomki-share-page" style={{ minHeight: '100vh', background: '#0a0a0a', color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 24 }}>
          <span className="material-icons" style={{ color: '#e33835', fontSize: 28 }}>smart_display</span>
          <span style={{ fontFamily: 'Orbitron, sans-serif', letterSpacing: 4, fontSize: 22, fontWeight: 700 }}>VROOMKI</span>
        </div>

        {loading && <p style={{ color: '#888' }}>Ładowanie...</p>}
        {error && !loading && <p style={{ color: '#e33835' }}>{error}</p>}

        {!loading && !error && post && (
          <>
            {cover && (
              <div style={{ borderRadius: 16, overflow: 'hidden', marginBottom: 20, border: '1px solid #e3383540' }}>
                {post.videos?.length > 0 ? (
                  <video src={cover} controls style={{ width: '100%', maxHeight: 360, display: 'block', background: '#111' }} />
                ) : (
                  <img src={cover} alt="" style={{ width: '100%', maxHeight: 360, objectFit: 'cover', display: 'block' }} />
                )}
              </div>
            )}
            <p style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 14, marginBottom: 8 }}>@{post.author?.username}</p>
            {post.caption && <p style={{ color: '#aaa', marginBottom: 24, lineHeight: 1.5 }}>{post.caption}</p>}
          </>
        )}

        <button
          type="button"
          onClick={openApp}
          style={{
            width: '100%',
            padding: '16px 24px',
            borderRadius: 14,
            border: 'none',
            background: '#e33835',
            color: '#fff',
            fontFamily: 'Orbitron, sans-serif',
            fontSize: 12,
            letterSpacing: 2,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          OTWÓRZ W VROOM
        </button>
        <p style={{ color: '#555', fontSize: 12, marginTop: 16 }}>
          Zainstaluj aplikację VROOM, aby oglądać rolki i komentować.
        </p>
      </div>
    </div>
  );
}
